import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';

const Fetching = ({ fetching, willUseSampleData }) => {
  if (!fetching || willUseSampleData) return null;

  const { Block, Loader } = UX2.Element;
  const wrapperStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '0px',
    bottom: '0px',
    left: '0px',
    right: '0px',
    minHeight: '100px',
    zIndex: 200
  };

  return (
    <Block style={ wrapperStyles }>
      <Loader size='large' display='block' fontColor='lowContrast' style={{ opacity: 0.5 }} />
    </Block>
  );
};

Fetching.propTypes = {
  fetching: PropTypes.bool,
  willUseSampleData: PropTypes.bool
};

Fetching.defaultProps = {
  fetching: false,
  willUseSampleData: false
};

export default Fetching;
